import {easasAxios} from "../../../services/HttpService";
import {ScadaJson, ScadaProps} from "./scadaTypes";
import {getEasasRestUrl} from "../../../utils/utils";


export function getScadaImageUrl(scadaProps: ScadaProps | ScadaJson) {
    return getEasasRestUrl() + "/images/" + scadaProps.scadaBackgroundId;
}

export function getScadaData(identifiers: Array<string>, refTime?: string) {
    return easasAxios.post("/datasetData/dataInfoRecent", identifiers, {params: {refTime: refTime}})
        .then(res => res.data)
}